import { cva, type VariantProps } from "./style.utils";

export type CheckboxVariants = VariantProps<typeof checkboxVariants>;

export const checkboxVariants = cva({
  base: [
    // layout
    "size-16px shrink-0",
    // radii/shadow
    "rounded",
    // border
    "border border-shade-50",
    // background
    "bg-white",
    // foreground
    "text-white",
    // animation
    "transition-colors",
    // focus outline/border
    "focus-visible:outline-1 focus-visible:outline-offset-0",
    "focus-visible:border-ring focus-visible:outline-ring-normal",

    // checked/indeterminate border
    "data-[state=checked]:border-transparent",
    "data-[state=indeterminate]:border-transparent",
    // checked/indeterminate background
    "data-[state=checked]:bg-primary-100",
    "data-[state=indeterminate]:bg-primary-100",
    // checked/indeterminate focus border
    "focus-visible:data-[state=checked]:border-transparent",
    "focus-visible:data-[state=indeterminate]:border-transparent",
    // checked/indeterminate focus offset
    "focus-visible:data-[state=checked]:outline-offset-4",
    "focus-visible:data-[state=indeterminate]:outline-offset-4",
  ],
  variants: {
    invalid: {
      true: "",
      false: "",
    },
    disabled: {
      true: "",
      false: "",
    },
  },
  compoundVariants: [
    {
      invalid: true,
      disabled: false,
      className: [
        // border
        "border-error-80",
        // background
        "bg-error-20",
        // checked/indeterminate border
        "data-[state=checked]:border-transparent",
        "data-[state=indeterminate]:border-transparent",
        // checked/indeterminate background
        "data-[state=checked]:bg-error-100",
        "data-[state=indeterminate]:bg-error-100",
      ],
    },
    {
      invalid: [true, false],
      disabled: true,
      className: [
        // border
        "border-shade-20",
        // background
        "bg-shade-8",
        // checked/indeterminate border
        "data-[state=checked]:border-transparent",
        "data-[state=indeterminate]:border-transparent",
        // checked/indeterminate background
        "data-[state=checked]:bg-shade-20",
        "data-[state=indeterminate]:bg-shade-20",
        // cursor
        "cursor-not-allowed",
      ],
    },
  ],
  defaultVariants: {
    invalid: false,
    disabled: false,
  },
});
